<div
  class="checkbox-container"
  (click)="checkboxClick.emit()"
  [class]="{
    'checkbox-large': size() === InputSize.large,
    'checkbox-small': size() === InputSize.small,
    'checkbox-disabled': disabled(),
    'checkbox-selected': selected(),
  }">
  <div class="checkbox-box-container">
    <div class="checkbox-box">
      <mat-icon class="checkbox-icon" [svgIcon]="indeterminate() ? 'minus' : 'check'"></mat-icon>
    </div>
  </div>
  <div class="checkbox-label">
    <ng-content></ng-content>
  </div>
</div>
